module.exports = __webpack_public_path__ + "static/media/syedadam.b9602157.jpeg";